import { useEffect } from "react";

function usePostMessage<TData>(
    handleOnPostMessage: (message: TData) => Promise<void>,
    isAValidEvent: (message: TData, eventOrigin: string, eventSource: EventTarget) => boolean
): void {
    useEffect(() => {
        const handler = async function(event: MessageEvent): Promise<void> {
            if (!isAValidEvent(event.data, event.origin, event.source)) {
                return;
            }

            await handleOnPostMessage(event.data);
        };

        window.addEventListener("message", handler);
        return () => {
            window.removeEventListener("message", handler);
        };
    }, [handleOnPostMessage, isAValidEvent]);
}

export default usePostMessage;
